import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';

import { PermissionAction, RoleAction } from '../../store/actions';

class Form extends PureComponent {
  static propTypes = {
    createRole: PropTypes.func,
    editRole: PropTypes.func,
    getPermissions: PropTypes.func,
    getRole: PropTypes.func,
    permissions: PropTypes.arrayOf(PropTypes.object),
    role: PropTypes.object,
    roleId: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.state = this.getInitialState(props.role);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    if (this.props.roleId) {
      this.props.getRole(this.props.roleId);
    }
  }

  componentDidUpdate(props, _state, _snapshot) {
    if (JSON.stringify(props.role) !== JSON.stringify(this.props.role)) {
      this.setState({ ...this.getInitialState(this.props.role) });
    }
  }

  getInitialState(role) {
    return {
      name: role?.name || '',
      permissions:
        role?.permissions?.reduce?.((ids, row) => {
          ids?.push?.(row.id);
          return ids;
        }, []) || [],
      permissions_selected:
        role?.permissions?.map?.(row => ({ label: row.name, value: row.id })) ||
        [],
    };
  }

  onChange(event) {
    const { target: { name, value } = {} } = event;
    this.setState({ [name]: value });
  }

  onClear(_) {
    this.setState(this.getInitialState());
  }

  onMultiSelect(options, action) {
    const { _name, name } = action;
    const values = options?.reduce?.((a, { value }) => {
      a?.push?.(value);
      return a;
    }, []);
    this.setState({ [name]: options, [_name]: values });
  }

  onSubmit(event) {
    event.preventDefault();
    if (!confirm('Are you sure?')) {
      return;
    }
    if (this.props.roleId) {
      this.props.editRole(this.props.roleId, this.state);
    } else {
      this.props.createRole(this.state);
    }
  }

  render() {
    return (
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">
                {this.props.roleId ? 'Edit' : 'Create'} Role
              </h3>
            </div>
            <form onSubmit={this.onSubmit.bind(this)}>
              <div className="card-body">
                <div className="form-row">
                  <div className="form-group col">
                    <label htmlFor="name">Name</label>
                    <input
                      className="form-control"
                      id="name"
                      name="name"
                      onChange={this.onChange}
                      placeholder="Name"
                      type="text"
                      value={this.state.name}
                    />
                  </div>
                  <div className="form-group col">
                    <label htmlFor="permissions">Permission(s)</label>
                    <Select
                      id="permissions"
                      isMulti
                      name="permissions_selected"
                      onChange={(option, action) =>
                        this.onMultiSelect(option, {
                          ...action,
                          _name: 'permissions',
                        })
                      }
                      onInputChange={value => {
                        value && this.props.getPermissions({ query: value });
                      }}
                      options={this.props.permissions}
                      placeholder="Select Permission(s)"
                      value={this.state.permissions_selected}
                    />
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <button className="btn btn-primary" type="submit">
                  Save
                </button>
                <button
                  className="btn btn-warning float-right"
                  onClick={this.onClear.bind(this)}
                  type="reset"
                >
                  Clear
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  permissions: state?.permission?.list?.data?.map?.(row => ({
    label: row.name,
    value: row.id,
  })),
  role: state?.role?.detail,
  roleId: Number(props?.match?.params?.id),
});

const mapDispatchToProps = dispatch => ({
  createRole: data => dispatch(RoleAction.createRole(data)),
  editRole: (id, data) => dispatch(RoleAction.editRole(id, data)),
  getPermissions: params => dispatch(PermissionAction.getPermissions(params)),
  getRole: id => dispatch(RoleAction.getRole(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form);
